module.exports = "/_next/static/images/pa-ee29267418313feec4ed31bcf0496b42.svg";